import { computed, ref, watch, type ComputedRef } from 'vue'
import type { OcrBlock } from '@/types/ainotebook'
import { normalizeHex } from '@/utils/ainotebook/color'

export function useColorBinding(selectedBlock: ComputedRef<OcrBlock | null>) {
  const selectedColor = computed({
    get() {
      return normalizeHex(selectedBlock.value?.color)
    },
    set(v: string) {
      const b = selectedBlock.value
      if (!b) return
      b.color = normalizeHex(v)
    }
  })

  const hexDraft = ref('')

  watch(
    () => selectedBlock.value?.id,
    () => { hexDraft.value = selectedColor.value },
    { immediate: true }
  )

  watch(
    () => selectedColor.value,
    (c) => { hexDraft.value = c }
  )

  watch(
    () => selectedBlock.value?.color,
    (v) => {
      const b = selectedBlock.value
      if (!b) return
      const nv = normalizeHex(v)
      if (b.color !== nv) b.color = nv
      if (hexDraft.value !== nv) hexDraft.value = nv
    },
    { immediate: true }
  )

  function onColorPick(e: Event) {
    const v = (e.target as HTMLInputElement).value
    selectedColor.value = v
    hexDraft.value = selectedColor.value
  }

  function commitHex() {
    selectedColor.value = hexDraft.value
    hexDraft.value = selectedColor.value
  }

  return { selectedColor, hexDraft, onColorPick, commitHex }
}
